
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { BlogService } from '@/services/blog/blogService';

export const useBlogPosts = () => {
  const [searchQuery, setSearchQuery] = useState('');
  
  const { data: posts, isLoading, error } = useQuery({
    queryKey: ['blogPosts', 'admin'],
    queryFn: async () => {
      return await BlogService.getAllPosts();
    },
  });
  
  const filteredPosts = posts?.filter((post: { title: string; slug: string }) =>
    post.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
    post.slug.toLowerCase().includes(searchQuery.toLowerCase())
  ) || [];

  return {
    posts: filteredPosts,
    isLoading,
    error,
    searchQuery,
    setSearchQuery,
  };
};
